import ivy_tn from "assets/ivy.webp";

import descriptive_tn from 'assets/category/descriptive.png';
import expository_tn from 'assets/category/expository.png';
import narrative_tn from 'assets/category/narrative.png';
import persuasive_tn from 'assets/category/persuasive.png';
import reflective_tn from 'assets/category/reflective.png';
import personal_tn from 'assets/category/personal_narrative.jpeg';
import biography_tn from 'assets/category/biography.jpeg';
import scifi_tn from 'assets/category/sci-fi.jpeg';
import fable_tn from 'assets/category/fable.jpeg';
import myth_tn from 'assets/category/myth.png';
import memoir_tn from 'assets/category/memoir.png';

import fantasy_tn from 'assets/story/fantasy.webp';
import horror_tn from 'assets/story/horror.jpeg';
import fairy_tale_tn from 'assets/story/fairy_tale.jpeg';

import family_edu_tn from 'assets/blog/family_edu.jpeg';
import writing_tn from 'assets/blog/writing.jpeg';
import co_writing_tn from 'assets/blog/co_writing.jpg';

import adventure1_tn from 'assets/miscs/adventure_1.png';
import adventure2_tn from 'assets/miscs/adventure_2.png';
import award_tn from 'assets/miscs/award.png';
import birthday_tn from 'assets/miscs/birthday.png';
import butterfly_tn from 'assets/miscs/butterfly.png';
import classroom_tn from 'assets/miscs/classroom.png';
import cook_tn from 'assets/miscs/cook.png';
import culture_tn from 'assets/miscs/culture.png';
import family_tn from 'assets/miscs/family.png';
import friendship_tn from 'assets/miscs/friendship.png';
import future_tn from 'assets/miscs/future.png';
import game_tn from 'assets/miscs/game.png';
import help_tn from 'assets/miscs/help.png';
import leadership_tn from 'assets/miscs/leadership.png';
import mirror_tn from 'assets/miscs/mirror.png';
import pet_tn from 'assets/miscs/pet.png';
import portal_tn from 'assets/miscs/portal.png';
import politician_tn from 'assets/miscs/politician.png';
import reading_tn from 'assets/miscs/reading.png';
import robot_tn from 'assets/miscs/robot.png';
import school_tn from 'assets/miscs/school.png';
import show_tn from 'assets/miscs/show.png';
import sleep_tn from 'assets/miscs/sleep.png';
import sports_tn from 'assets/miscs/sports.png';
import superhero_tn from 'assets/miscs/superhero.png';
import tech_tn from 'assets/miscs/tech.png';
import tradition_tn from 'assets/miscs/tradition.png';
import treasure_tn from 'assets/miscs/treasure.png';
import wonderland1_tn from 'assets/miscs/wonderland_1.png';
import wonderland2_tn from 'assets/miscs/wonderland_2.png';
import write_letter_tn from 'assets/miscs/writing.png';
import yarn_tn from 'assets/miscs/yarn.png';

export const getImageUrl = (type) => {
  if (!type) return narrative_tn;
  switch (type) {
    case 'ivy':
      return ivy_tn;

    case 'descriptive':
      return descriptive_tn;
    case 'expository':
      return expository_tn;
    case 'narrative':
      return narrative_tn;
    case 'persuasive':
    case 'argumentative':
      return persuasive_tn;
    case 'reflective':
      return reflective_tn;
    case 'biography':
      return biography_tn;
    case 'personal narrative':
      return personal_tn;
    case 'sci-fi':
      return scifi_tn;
    case 'fable':
      return fable_tn;
    case 'myth':
      return myth_tn;
    case 'memoir':
      return memoir_tn;
    // stories
    case 'fantasy':
      return fantasy_tn;
    case 'fairy tale':
      return fairy_tale_tn;
    case 'horror':
      return horror_tn;
    // blogs
    case 'writing':
      return writing_tn;
    case 'family_edu':
      return family_edu_tn;
    case 'co_writing':
      return co_writing_tn;
    // miscs
    case 'adventure1':
      return adventure1_tn;
    case 'adventure2':
      return adventure2_tn;
    case 'award':
      return award_tn;
    case 'birthday':
      return birthday_tn;
    case 'butterfly':
      return butterfly_tn;
    case 'classroom':
      return classroom_tn;
    case 'cook':
      return cook_tn;
    case 'culture':
      return culture_tn;
    case 'family':
      return family_tn;
    case 'friendship':
      return friendship_tn;
    case 'future':
      return future_tn;
    case 'game':
      return game_tn;
    case 'help':
      return help_tn;
    case 'leadership':
      return leadership_tn;
    case 'mirror':
      return mirror_tn;
    case 'pet':
      return pet_tn;
    case 'politician':
      return politician_tn;
    case 'portal':
      return portal_tn;
    case 'reading':
      return reading_tn;
    case 'robot':
      return robot_tn;
    case 'school':
      return school_tn;
    case 'show':
      return show_tn;
    case 'sleep':
      return sleep_tn;
    case 'sports':
      return sports_tn;
    case 'superhero':
      return superhero_tn;
    case 'tech':
      return tech_tn;
    case 'tradition':
      return tradition_tn;
    case 'treasure':
      return treasure_tn;
    case 'wonderland1':
      return wonderland1_tn;
    case 'wonderland2':
      return wonderland2_tn;
    case 'write letter':
      return write_letter_tn;
    case 'yarn':
      return yarn_tn;
    default:
      return type;
  }
};
